module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/bottom-decoration-93345423545fa78456afa92d277a8cc5.png";